import {
  API_FETCH_COUNTRY_ISO_DICTIONARY,
  API_GET_SOURCE_GEO,
} from "@/config/api.config";
import apiCall from "@/utils/api";
import downloadFile from "@/utils/file";

export const FETCH_SOURCE_GEO = "FETCH_SOURCE_GEO";
export const FETCH_SOURCE_GEO_FILE = "FETCH_SOURCE_GEO_FILE";
export const SET_SOURCE_GEO = "SET_SOURCE_GEO";
export const FETCH_COUNTRY_ISO_DICTIONARY = "FETCH_COUNTRY_ISO_DICTIONARY";
export const SET_COUNTRY_ISO_DICTIONARY = "SET_COUNTRY_ISO_DICTIONARY";

export default {
  [FETCH_SOURCE_GEO]({ commit }, { params } = {}) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    return apiCall({
      method: API_GET_SOURCE_GEO,
      params,
    })
      .then(({ status, data }) => {
        if (status === 200 && !data.error) {
          commit(SET_SOURCE_GEO, data.data);
          return data;
        }
        throw data;
      })
      .catch((error) => {
        commit("SET_ERROR", error.details || error.message);
        throw error;
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  [FETCH_COUNTRY_ISO_DICTIONARY]({ commit }) {
    return new Promise((resolve, reject) => {
      return apiCall({
        method: API_FETCH_COUNTRY_ISO_DICTIONARY,
      }).then((response) => {
        try {
          let { status, data } = response;
          if (status === 200 && !data.error) {
            commit(SET_COUNTRY_ISO_DICTIONARY, data);
            resolve(data);
          } else {
            reject(data);
          }
        } catch (e) {
          // eslint-disable-next-line no-empty
        }
      });
    });
  },

  [FETCH_SOURCE_GEO_FILE](_, params = {}) {
    return downloadFile({
      method: API_GET_SOURCE_GEO,
      params: { ...params, format: "excel" },
    });
  },
};
